<template>
  <div class="container">
    <div @click="goWxApp">点击跳转</div>
  </div>
</template>

<script>
import { channelInfo } from '@/api/data'

export default {
  data() {
    return {
      channelCode: '', // code
      skipPage: '',
      skipPath: '', // 跳转路径
      skipPlatform: '' // 跳转平台
    }
  },
  created() {},
  mounted() {
    this.channelCode = this.$route.query.channelCode || ''
    this.fetData()
  },
  methods: {
    fetData(){
      // 1572133521626107904
      channelInfo(this.channelCode).then(res => {
        let data = res.data.data
        this.skipPage = data.skipPage
        this.skipPath = data.skipPath
        this.skipPlatform = data.skipPlatform

        this.goProgran()
      })
    },

    goWxApp() {
      /**
       *    payFee.缴费通知
       *    activity.活动通知
       *    investActivity.招商活动
       *    inviteJoin.邀请入会
       *    customizeNotice.自定义通知
       */
      if (this.skipPath) {
        window.location.href = this.skipPath
      }else{
        channelInfo(this.channelCode).then(res => {
          let data = res.data.data
          this.skipPath = data.skipPath
          if (this.skipPath) {
            window.location.href = this.skipPath
          }
        })
      }
    },

    goProgran(){
      if (this.skipPath) {
        window.location.href = this.skipPath
      }
    }
  }
}
</script>

<style lang="less">
.container {
  width: 100%;
  text-align: center;
  margin-top: 35vh;
}
</style>
